import { useCallback, useEffect, useState } from 'react';
import { getCourse2User } from 'src/api/apis';
import { type CourseHistory } from '../utils/type';
import { UID_KEY } from './useLogin';

export default function useUserCourseHistory () {
  const [histories, setHistories] = useState<CourseHistory[]>([]);

  const refetchHistories = useCallback(async () => {
    const uid = sessionStorage.getItem(UID_KEY);

    const historyList = await getCourse2User({ uid });

    setHistories(historyList.data.course2user);
  }, []);

  useEffect(() => {
    refetchHistories();
  }, [refetchHistories]);

  return { histories, refetchHistories };
}
